<template>
  <div :class="bem()">
    <div :class="bem('subtitle-wrapper')">
      <VisionIcon
        icon="inf-recycled"
        size="stretch"
        gradient="default"
        :class="bem('icon')"
      />
      <BaseHeading
        tag="h4"
        size="h4"
        :class="bem('subtitle')"
      >
        Infinite 100% Recycled Frames.
      </BaseHeading>
    </div>
    
    <BaseHeading
      tag="h1"
      size="h1"
      :class="bem('title')"
    >
      <span :class="bem('gradient')">7x</span> lower impact than virgin plastic.
    </BaseHeading>

    <SecondaryLineLink
      is-button
      :class="bem('button')"
      @click="() => openModal('infinite')"
    >
      {{ $tr('Learn More') }}
    </SecondaryLineLink>
  </div>
</template>

<script>
export default {
  name: 'InfiniteBanner',

  setup() {
    const modalStore = useModalStore()

    const bem = useBEM('InfiniteBanner')

    return { modalStore, bem}
  },

  methods: {
    openModal (slug) {
      this.modalStore.OPEN_MODAL_PAGE({ slug })
    }
  }
}
</script>

<style lang="postcss" scoped>
.InfiniteBanner {
  &__subtitle-wrapper {
    @apply flex items-center
      space-x-3;

    @screen md {
      @apply space-x-4;
    }
  }

  &__icon {
    @apply w-8 h-8;

    @screen md {
      @apply w-10 h-10;
    }
  }

  &__subtitle,
  &__gradient {
    @apply inline-block
      text-transparent
      bg-clip-text;
    background-image: var(--gradient-default);
  }

  &__title {
    @apply max-w-[280px]
      mt-8;

    @screen md {
      @apply max-w-md
        mt-12;
    }
  }

  &__button {
    @apply mt-[60px];

    @screen md {
      @apply mt-20;
    }
  }
}
</style>
